import { createApp } from 'vue';
import { configureCompat } from '@vue/compat';
import App from './App.vue';

import router from 'src/router';

import 'devextreme/dist/css/dx.light.css';

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
library.add(fas);

// Configure global compat mode
configureCompat({
	MODE: 2,
	GLOBAL_MOUNT: false
});

import config from 'app-core/config';

const app = createApp(App);

// Suppress specific compat warnings from third-party libraries
app.config.warnHandler = (msg, instance, trace) => {
	// Suppress GLOBAL_MOUNT warning from third-party libraries (DevExtreme)
	if (msg.includes('GLOBAL_MOUNT')) {
		return;
	}
	// Log other warnings only in development mode
	if (process.env.NODE_ENV !== 'production') {
		console.warn(msg, trace);
	}
};

app.use(router);
app.use(config);
app.component('fas', FontAwesomeIcon);

app.mount('#app');
